var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointJars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.7501H2.75C2.21957 17.7501 1.71086 17.5394 1.33579 17.1643C0.960714 16.7892 0.75 16.2805 0.75 15.7501V2.7501C0.75 2.21966 0.960714 1.71096 1.33579 1.33588C1.71086 0.96081 2.21957 0.750096 2.75 0.750096H6.65C6.98449 0.746817 7.31445 0.827485 7.6097 0.984716C7.90495 1.14195 8.15604 1.37072 8.34 1.6501L9.15 2.8501C9.33211 3.12663 9.58003 3.35362 9.8715 3.5107C10.163 3.66778 10.4889 3.75004 10.82 3.7501H18.75C19.2804 3.7501 19.7891 3.96081 20.1642 4.33588C20.5393 4.71096 20.75 5.21966 20.75 5.7501V7.2501",
    stroke: "#9AA78F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.25 12.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65354 5.2035C0.453536 4.0035 0.513536 2.4035 1.45354 1.4735C1.67925 1.24734 1.94734 1.06791 2.24248 0.94548C2.53762 0.823055 2.85401 0.760039 3.17354 0.760039C3.49306 0.760039 3.80945 0.823055 4.10459 0.94548C4.39973 1.06791 4.66783 1.24734 4.89354 1.4735L5.25354 1.8135L5.59354 1.4735C5.81877 1.24518 6.08696 1.06369 6.38267 0.939522C6.67838 0.815348 6.99574 0.75094 7.31645 0.75001C7.63717 0.749081 7.9549 0.811648 8.25132 0.934105C8.54774 1.05656 8.81699 1.23649 9.04354 1.4635C9.99354 2.4135 10.0435 3.9935 8.84354 5.2035L5.25354 8.7535L1.65354 5.2035Z",
    stroke: "#9AA78F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointJars);
export default __webpack_public_path__ + "static/media/point-jars.397d70829167843707778e027f9bd8c6.svg";
export { ForwardRef as ReactComponent };